"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "currentColor",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "mic",
    transform: "translate(5.000000, 1.000000)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7,2.22044605e-16 C5.34314575,-2.22044605e-16 4,1.34314575 4,3 L4,11 C4,12.6568542 5.34314575,14 7,14 C8.65685425,14 10,12.6568542 10,11 L10,3 C10,1.34314575 8.65685425,2.22044605e-16 7,2.22044605e-16 Z",
      id: "Shape"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M14,9 L14,11 C13.9999999,14.8659932 10.8659932,17.9999999 7,17.9999999 C3.13400679,17.9999999 5.7607787e-08,14.8659932 -1.77635684e-15,11 L-1.77635684e-15,9",
      id: "Shape"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7,18 L7,22",
      id: "Shape"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M3,22 L11,22",
      id: "Shape"
    })]
  })
}));